export const STARS_COUNT = 5;
